import {
  CancelFlightByRecordLocator,
  CancelFlightRequest,
  NskCancellationReason,
  RefundDetailsByTicket,
  RefundType
} from '@tff/types/tff/cancel-flight-service';
import {RecordLocator} from '@tff/types';
import {CancellationForm} from '../../components/CancelBooking/models';
import { TargetEnvironment, TffBookingSource } from '@tff/types/tff';
import { NdcCancellationReason } from '@tff/types/tff/retrieve';

export interface BuildCancelRequestParams {
  bookingSource: TffBookingSource;
  recordLocator: string;
  refundType: RefundType;
  cancellationReason?: NdcCancellationReason | NskCancellationReason;
  calculatedServiceCharge?: number;
  hasPayment?: boolean;
  tfmPnr: RecordLocator;
  waivePenaltyFee: boolean;
  refundComment: string;
  isServicePackagesRefunded: boolean;
  checkRefundResponse?: any;
  formValues?: CancellationForm;
  targetEnvironment?: TargetEnvironment;
  offerId?: string;
  tffRefundDetailsTotalAmount?: number;
  tffRefundDetailsIsVoidable?: boolean;
  journeyOndsToCancel?: string[];
  refundByTicketNumber?: RefundDetailsByTicket[];
  orderId?: string;
}

export const queueSelectionsAreValid = (formValues?: CancellationForm): boolean => {
  if (!formValues?.queueSelections || formValues.queueSelections.length === 0) {
    return true;
  }

  return formValues.queueSelections.every(queue => queue.queue !== '' && queue.queueNote !== '');
};

export const buildCancelRequest = (params: BuildCancelRequestParams): CancelFlightByRecordLocator => {
  const {
    bookingSource,
    recordLocator,
    refundType,
    cancellationReason,
    calculatedServiceCharge,
    hasPayment,
    tfmPnr,
    waivePenaltyFee,
    refundComment,
    isServicePackagesRefunded,
    checkRefundResponse,
    formValues,
    targetEnvironment,
    offerId,
    tffRefundDetailsTotalAmount,
    tffRefundDetailsIsVoidable,
    journeyOndsToCancel,
    refundByTicketNumber,
    orderId,
  } = params;

  const filteredQueues = formValues?.queueSelections
    ?.filter(q => q.queue)
    .map(qp => ({ queue: qp.queue, note: qp.queueNote! }));

  return {
    action: 'cancel',
    bookingSource,
    recordLocator,
    typeOfRefund: refundType,
    cancellationReason,
    serviceChargeTui: calculatedServiceCharge,
    serviceChargeSource: 0,
    afterPayment: hasPayment,
    tfmPnr,
    waivePenaltyFee,
    bookingComment: cancellationReason + (refundComment ? '$$' + refundComment : ''),
    refundServicePackages: isServicePackagesRefunded,
    ...('orderReshopResponse' in (checkRefundResponse ?? {}) && checkRefundResponse?.orderReshopResponse
      ? {orderReshopResponse: checkRefundResponse.orderReshopResponse}
      : {}),
    ...(filteredQueues && filteredQueues.length > 0 ? {queues: filteredQueues} : {}),
    ...(targetEnvironment ? {targetEnvironment} : {}),
    ...(offerId ? {offerId} : {}),
    ...(tffRefundDetailsTotalAmount && !tffRefundDetailsIsVoidable
      ? {expectedRefundAmount: tffRefundDetailsTotalAmount}
      : {}),
    ...(journeyOndsToCancel ? {journeyOndsToCancel} : {}),
    ...(refundByTicketNumber && refundByTicketNumber.length > 0 ? {refundDetailsByTicketNumber: refundByTicketNumber} : {}),
    ...(bookingSource.startsWith('TUI-NDC') ? {orderId} : {agent: 'TFFX3'}),
  };
};
